// angular
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';

// others
import { AppService } from '../../../app.service';
import { AuthService } from '../../../core/auth.service';
import { ProfileService } from '../profile.service';
import { Router } from '@angular/router';
import { ProfileComponent } from '../profile.component';
import { finalize } from 'rxjs/operators';
import { MeRegisterService } from '../../register/me-register.service';
import { MeForgotPasswordService } from '../../auth/forgot-password/forgot-password.service';
import { KlenicoMeService } from '../../me.service';
import * as _ from 'lodash';

@Component({
    selector: 'my-account-card',
    templateUrl: './my-account-card.component.html',
    styleUrls: ['./my-account-card.component.scss'],
    providers: [MeForgotPasswordService]
})

export class MyAccountCardComponent extends ProfileComponent implements OnInit {
    data: any;
    submitted: boolean;
    checked: boolean = false;
    showMessage: boolean = false;

    @Input() callApi = true;
    @Input() blockData = false;
    @Input() profile : any;
    @Output() updateUI = new EventEmitter();
    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public coreService: CoreService,
        public router: Router,
        public profileService: ProfileService,
        public mePasswordService: MeForgotPasswordService,
        public authService: AuthService,
        public meService: KlenicoMeService
    ) {
        super(appService, translate, coreService, router, profileService, authService, meService);
    }

    ngOnInit() {
        this.urlAPI = 'b2c-patients/profile';
        this.languageLocale = this.appService.getLanguage() || this.translate.currentLang;
        if (this.callApi) {
            this.url = this.url + '/' + this.slug;
            this.getContent();
            this.translate.onLangChange.subscribe(value => {
                this.getContent();
            });
        } else {
            this.data = this.blockData['content'];
        }
    }

    ngAfterViewInit() {
        this.coreService.className = 'me-landing-page';
    }

    /**
     * @param params
     */
    openFormModal(params: Object, navigate = false) {
        this.initForm(params, navigate);

        this.profileService.getProfile(this.profile['id']).subscribe(response => {
            let editingData = response;
            this.languages = this.languages || JSON.parse(localStorage.getItem('languages'));
            let form = {};
            this.formLoading = false;
            /**
             * 1. Bind value
             * Display only the roles that the logged-in user can select
             */
            if (params['action'] === 'create') {
                if (this.roles != null) {
                    this.roles = [];
                }
            } else {
                const _self = this;
            }

            let disabled = params['action'] === 'read' ? true : false;

            for (let column in editingData) {
                if (editingData.hasOwnProperty(column)) {
                    if(params['fieldName'] === 'email'){
                        form['email'] = {value: '', disabled: disabled};
                        continue;
                    }
                    form[column] = {value: editingData[column], disabled: disabled};
                }
            }

            if (this.form != null) {
                this.form.reset(form);
            } else {
                this.form = this.fb.group(form);
            }

            this.showModal();
            this.isLoading = false;
        });
    }

    submit(value, valid, form) {
        this.editting = false;
        if(this.params['action'] === 'delete'){
            return super.delete(this.form.value, this.form.valid, this.params['url'] + '/' + this.params['action']);
        }
        return super.submit(this.form.value, this.form.valid, this.params['url'] + '/' + this.params['action']);
    }

    handleResponse(response) {
        this.isUpdated = true;
        if (response['message']) {
            this.responseMessage = response['message'];

            setTimeout(() => {
                this.hideModal();
            }, 2000);
        }
    }

    sendVericationMail(value, isValid){
        this.submitted = true;
        if (!isValid) {
            return;
        }

        this.appService.isLoading = true;
        this.mePasswordService.forgotPassword(value.email).subscribe((res) => {
                this.appService.isLoading = false;
                this.responseMessage = res['message'];
                this.showMessage = true;
            },
            (error) => {
                this.errorMessage = error.error.error;
                this.appService.isLoading = false;
            });
    }

    changeLanguage() {
        const language = _.find(this.languages, {'locale': this.languageLocale});
        const patientId = this.authService.patientId;
        let data = {
            language_id: language.id
        };
        if(!patientId){
            this.appService.setLanguage(this.languageLocale);
            return;
        }
        this.appService.isLoading = true;
        this.profileService.patientId = patientId;
        this.profileService.updateProfile(data).subscribe(response => {
            this.appService.setLanguage(this.languageLocale);
            this.authService.setUserLanguage(language);
            location.reload();
        });
    }
}
